import React from 'react';
import { CgMenuGridR } from "react-icons/cg";
import Reviews from '../../courses/CoursesSingle/Reviews';

const BlogContent = () => {
   return (
      <section className="py-8 md:py-12 sm:px-6 lg:px-[90px]">
         <div className="container mx-auto px-4">
            {/* Article Content */}
            <div className="max-w-4xl mx-auto bg-white dark:bg-dark-5 rounded-lg overflow-hidden p-6 md:p-8 pb-0 shadow-sm">
               <h4 className="text-base md:text-lg text-dark-1 dark:text-white font-medium mb-6 md:mb-8">What makes a good brand book?</h4>

               <p className="mb-6 md:mb-8 text-light-1 dark:text-gray-300 text-sm md:text-[15px]">
                  Sed viverra ipsum nunc aliquet bibendum enim facilisis gravida. Diam phasellus vestibulum lorem sed risus ultricies. Magna sit amet purus gravida quis blandit. Arcu cursus vitae congue mauris. Nunc mattis enim ut tellus elementum sagittis vitae et leo. Semper risus in hendrerit gravida rutrum quisque non. At urna condimentum mattis pellentesque id nibh tortor. A erat nam at lectus urna duis convallis convallis tellus. Sit amet mauris commodo quis imperdiet massa. Vitae congue eu consequat ac felis.
               </p>
               <ul className="space-y-3 text-[15px] mb-8 pl-5 list-disc text-light-1 dark:text-gray-300 text-sm md:text-[15px]">
                  <li>Sed viverra ipsum nunc aliquet bibendum enim facilisis gravida.</li>
                  <li>At urna condimentum mattis pellentesque id nibh.</li>
                  <li>Magna etiam tempor orci eu lobortis elementum.</li>
                  <li>Bibendum est ultricies integer quis. Semper eget duis at tellus.</li>
               </ul>

               <p className="mb-8 text-light-1 text-[15px] dark:text-gray-300 text-sm md:text-[15px]">
                  Donec purus posuere nullam lacus aliquam egestas arcu. A egestas a, tellus massa, ornare vulputate. Erat enim eget laoreet ullamcorper lectus aliquet nullam tempus id. Dignissim convallis quam aliquam rhoncus, lectus nullam viverra. Bibendum dignissim tortor, phasellus pellentesque commodo, turpis vel eu. Donec consectetur ipsum nibh lobortis elementum mus velit tincidunt elementum. Ridiculus eu convallis eu mattis iaculis et, in dolor. Sem libero, tortor suspendisse et, purus euismod posuere sit. Risus dui ut viverra venenatis ipsum tincidunt non, proin. Euismod pharetra sit ac nisi. Erat lacus, amet quisque urna faucibus. Rhoncus praesent faucibus rhoncus nec adipiscing tristique sed facilisis velit.
                  <br /><br />
                  Neque nulla porta ut urna rutrum. Aliquam cursus arcu tincidunt mus dictum sit euismod cum id. Dictum integer ultricies arcu fermentum fermentum sem consectetur. Consectetur eleifend aenean eu neque euismod amet parturient turpis vitae. Faucibus ipsum felis et duis fames.
               </p>

               {/* Images Grid */}
               <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 my-6 md:my-8">
                  <img
                     src="/blog/blog-single/1.png"
                     alt="Blog content"
                     className="w-full rounded-lg"
                  />
                  <img
                     src="/blog/blog-single/2.png"
                     alt="Blog content"
                     className="w-full rounded-lg"
                  />
               </div>

               <p className="text-light-1 dark:text-gray-300 text-sm md:text-[15px]">
                  Donec purus posuere nullam lacus aliquam egestas arcu. A egestas a, tellus massa, ornare vulputate. Erat enim eget laoreet ullamcorper lectus aliquet nullam tempus id. Dignissim convallis quam aliquam rhoncus, lectus nullam viverra. Bibendum dignissim tortor, phasellus pellentesque commodo, turpis vel eu. Donec consectetur ipsum nibh lobortis elementum mus velit tincidunt elementum. Ridiculus eu convallis eu mattis iaculis et, in dolor. Sem libero, tortor suspendisse et, purus euismod posuere sit. Risus dui ut viverra venenatis ipsum tincidunt non, proin. Euismod pharetra sit ac nisi. Erat lacus, amet quisque urna faucibus. Rhoncus praesent faucibus rhoncus nec adipiscing tristique sed facilisis velit.
                  <br /><br />
                  Neque nulla porta ut urna rutrum. Aliquam cursus arcu tincidunt mus dictum sit euismod cum id. Dictum integer ultricies arcu fermentum fermentum sem consectetur. Consectetur eleifend aenean eu neque euismod amet parturient turpis vitae. Faucibus ipsum felis et duis fames.
               </p>

               {/* Social Share & Tags */}
               <div className="max-w-4xl mx-auto mt-5 flex flex-col sm:flex-row justify-between items-center py-6 gap-4 sm:gap-0">
                  <div className="flex items-center">
                     <span className="font-medium mr-4 sm:mr-6 text-sm sm:text-[15px] text-dark-1 dark:text-white">Share</span>
                     <div className="flex space-x-3 sm:space-x-4 text-sm sm:text-[15px]">
                        {['Fb', 'Tw', 'In', 'Ln'].map((social) => (
                           <a key={social} href="#" className="text-gray-600 dark:text-gray-400 hover:text-purple-1 dark:hover:text-purple-300">
                              {social}
                           </a>
                        ))}
                     </div>
                  </div>

                  <div className="flex flex-wrap gap-2">
                     {['Courses', 'Learn', 'Online', 'LMS'].map((tag) => (
                        <a
                           key={tag}
                           href="#"
                           className="px-3 sm:px-[17px] py-1 sm:py-2 text-xs sm:text-[11px] bg-light-3 dark:bg-dark-2
                           text-dark-1 dark:text-white border border-light-3 dark:border-dark-2 rounded-full
                           hover:bg-purple-1 hover:text-white hover:border-purple-1
                           dark:hover:border-purple-300 transition-colors"
                        >
                           {tag}
                        </a>
                     ))}
                  </div>
               </div>
            </div>

            {/* Author Bio */}
            <div className="max-w-4xl mx-auto mt-2 pt-6 md:pt-[30px] border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-start px-4 gap-4 sm:gap-8">
               <img
                  src="/blog/blog-single/author.png"
                  alt="Author"
                  className="w-12 sm:w-16 h-12 sm:h-16 rounded-full"
               />
               <div className='sm:ml-8'>
                  <h4 className="text-base sm:text-lg font-medium text-dark-1 dark:text-white">Brooklyn Simmons</h4>
                  <p className="text-gray-600 dark:text-gray-400 text-xs sm:text-sm mt-1">Medical Assistant</p>
                  <p className="mt-4 sm:mt-6 text-light-1 dark:text-gray-400 text-sm sm:text-[15px]">
                     Etiam vitae leo et diam pellentesque porta...
                  </p>
               </div>
            </div>

            {/* Navigation */}
            <div className="max-w-4xl mx-auto mt-6 sm:mt-8 py-6 sm:py-8 border-t border-b border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row justify-between gap-4 sm:gap-0">
               <a href="#" className="flex items-center text-dark-1 dark:text-white text-sm sm:text-[15px] px-0 sm:px-6">
                  <svg className="w-4 sm:w-5 h-4 sm:h-5 mr-3 sm:mr-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  <div>
                     <div className="font-medium">Prev</div>
                     <p className="mt-1 sm:mt-2 text-xs sm:text-sm">5 awesome steps to get rid of stress</p>
                  </div>
               </a>

               <div className='flex items-center justify-center sm:justify-start'>
                  <CgMenuGridR size={24} className="text-dark-1 dark:text-white" />
               </div>

               <a href="#" className="flex items-center text-dark-1 dark:text-white text-right text-sm sm:text-[15px] px-0 sm:px-6">
                  <div className="text-right">
                     <div className="font-medium">Next</div>
                     <p className="mt-1 sm:mt-2 text-xs sm:text-sm">Happy clients leave positive feedback</p>
                  </div>
                  <svg className="w-4 sm:w-5 h-4 sm:h-5 ml-3 sm:ml-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
               </a>
            </div>

            {/* Reviews */}
            <div className="max-w-4xl mx-auto mt-8">
               <Reviews />
            </div>
         </div>
      </section>
   );
};

export default BlogContent;